import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from 'src/app/services/http/http.service';
import { HelperService, DialogService, LanguageService, S3Service } from 'src/app/services';
import { Path } from '../../../utils/constant/paths';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CampaignMaintenanceService {
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    private s3: S3Service,
    private http: HttpService,
    private helper: HelperService,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }
  
  getList(data?: any) {
    return this.http.post(Path.CAMPAIGNS.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.CAMPAIGNS.GET_DETAIL, params);
  }
  
  insert(data?: any): Observable<any> {
    return this.http.post(Path.CAMPAIGNS.INSERT, data);
  }
  
  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_CAMPAIGN_MAINTENACE, data);
  }

  chooseFile(ev, formGroup) {
    let loadingDialogRef = this.dialogService.loading();

    let tempObj = {
      folderName: "campaign_wizard",
      file: _.get(ev.target, 'files[0]'),
    }
    
    this.s3.upload(tempObj, (err, res) => {
      if (err) {
        if(environment.showLogs) {
          console.log("Error uploading: ", err);
        }
        // this.dialogService.confirm({
        //   title: "UPLOAD FAILED",
        //   message: this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}),
        //   button: "Close",
        //   hasCancel: false
        // });
        loadingDialogRef.close();
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}));
        return err;
      }
      else if (res) {
        if(environment.showLogs) {
          console.log(res);
        }
        
        formGroup.get('reference_filename').setValue(res);
        loadingDialogRef.close();
        // this.dialogService.confirm({
        //   title: this.languageService.getTranslation("MSG_UPLOADING_SUCCESS", {}),
        //   message: this.languageService.getTranslation("MSG_SUCCESS_EMAIL_UPLOAD", {}),
        //   button: "Close",
        //   hasCancel: false
        // });
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_SUCCESS", {}));
      }
    })
  }
}
